import Avatar from '@mui/material/Avatar';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import AILogoSimpleIcon from 'assets/icons/quicken-ai/ai-logo-simple.inline.svg';
import { AI_LOGO_SIMPLE_GLYPH_SIZE } from 'assets/icons/quicken-ai/aiLogoSimple';

const useStyles = makeStyles()((theme) => ({
  avatar: {
    background: theme.palette.ai.gradientRadial,
    color: theme.palette.common.white,
    '& svg': {
      width: AI_LOGO_SIMPLE_GLYPH_SIZE,
      height: AI_LOGO_SIMPLE_GLYPH_SIZE,
      fill: theme.palette.common.white,
    },
  },
}));

type AIAvatarProps = {
  name?: string;
  src?: string;
  width?: number | string;
  height?: number | string;
};

export const AIAvatar: React.FC<AIAvatarProps> = ({ width = 32, height = 32 }) => {
  const { classes } = useStyles();

  return (
    <Avatar className={classes.avatar} alt={'AI'} sx={{ width, height }}>
      <AILogoSimpleIcon />
    </Avatar>
  );
};
